<template>
    <div class="ion-page">
        <ion-header class="rp-mobile">
            <ion-toolbar class="mobile-header-toolbar">
                <ion-buttons v-slot: start>
                    <ion-menu-button></ion-menu-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-header class="rp-desktop">
            <ion-toolbar>
                <ion-buttons v-slot: start>
                    <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
                    <ion-grid class="title-wrapper ion-no-padding">
                        <ion-row>
                            <ion-col size-md="8">
                                <ion-title>Station Details</ion-title>
                            </ion-col>
                            <ion-col size-md="4"  class="ion-no-padding ion-text-right">
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content class="book-page">
            <div class="rectangle">
                <ion-grid>
                    <ion-row>
                        <ion-col>
                            <div class="flight-types">
                                <input type="radio" name="flight-type" value="station" id="station" checked/>
                                <label for="station" @click="selectSegment('station')">
                                    STATION
                                </label>

                                <input type="radio" name="flight-type" value="charger" id="charger"  />
                                <label for="charger" @click="selectSegment('charger')">
                                    CHARGERS
                                </label>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
            <div v-if="displayStationInd">
                <ion-grid>
                    <ion-row class="rectangle"  v-if="displayStationInd">
                        <ion-col>
                            <div>
                            <ion-grid v-if="stationDetails != null">
                                <ion-row>
                                    <ion-col>
                                        <ion-label class="section-head">Basic Details</ion-label>
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>
                                        <ion-label class="section-item" >Station Name</ion-label>
                                        <p class="section-detail">{{ stationDetails.name }}</p>
                                    </ion-col>
                                    <ion-col>
                                        <ion-label class="section-item" >Organization</ion-label>
                                        <p class="section-detail">{{ stationDetails.org }}</p>
                                    </ion-col>
                                    <ion-col>
                                        <ion-label class="section-item" >Address</ion-label>
                                        <p class="section-detail">{{ stationDetails.address.city }}</p>
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>
                                        <ion-label class="section-item" >Activation Date</ion-label>
                                        <p class="section-detail">{{ stationDetails.orgDetails.orgActivationDate }} (EDT)</p>
                                    </ion-col>
                                    <ion-col>
                                        <ion-label class="section-item" >MSSA Serial number</ion-label>
                                        <p class="section-detail">{{ stationDetails.orgDetails.MSSASerialNo }}</p>
                                    </ion-col>
                                    <ion-col>
                                        <ion-label class="section-item" >MSSA Signed Date</ion-label>
                                        <p class="section-detail">{{ stationDetails.orgDetails.MSSASignedDate }} (EDT)</p>
                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </div>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
            <div v-if="!displayStationInd">
                <div v-if="stationDetails != null">
                    <ion-grid>
                        <ion-row class="rectangle">
                            <ion-col>
                                <div>
                                    <ion-row>
                                        <ion-col>
                                            <ion-row>
                                                <ion-col>
                                                    <ion-label class="section-head">Basic Details</ion-label>
                                                </ion-col>
                                            </ion-row>
                                            <ion-row>
                                                <ion-col>
                                                    <ion-label class="section-item" >Make</ion-label>
                                                    <p class="section-detail">{{ stationDetails.make }}</p>
                                                </ion-col>
                                                <ion-col>
                                                    <ion-label class="section-item" >Model</ion-label>
                                                    <p class="section-detail">{{ stationDetails.model }}</p>
                                                </ion-col>
                                                <ion-col>
                                                    <ion-label class="section-item" >Serial Number</ion-label>
                                                    <p class="section-detail">{{ stationDetails.serialNumber }}</p>
                                                </ion-col>
                                                <ion-col>
                                                    <ion-label class="section-item" >Status</ion-label>
                                                    <p class="section-detail">{{ stationDetails.status.name }}</p>
                                                </ion-col>
                                            </ion-row>
                                        </ion-col>
                                    </ion-row>
                                </div>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </div>
                <div v-if="stationDetails != null">
                    <ion-grid>
                        <ion-row>
                            <ion-col>
                                <CarterChargerSessionDetails />
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </div>
            </div>            
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonBackButton, IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import { EVCStationService } from "../../service/evcstation/stations.service";
import { EVCStation, EVCStationStatus } from "../../entity/location/evcstation";
import { refresh } from 'ionicons/icons';
import { ToastUtils } from "../../util/toast-utils";
import { PaginationUtils } from "../../util/pagination-utils";
// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datepicker from 'vue3-datepicker';
import moment from "moment";
import CarterBookNow from "@/views/carter/CarterBookNow.vue";
import CarterChargerSessionDetails from "./CarterChargerSessionDetails.vue";


export default defineComponent ({
    name: "carterStationDetails",
    components: {
        IonBackButton, datepicker, IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, 
        IonSelectOption, IonButton, IonIcon, IonSpinner, CarterBookNow, CarterChargerSessionDetails
    },
    data() {
        return {
            stationDetails: null,
            segmentName: "station",
            displayStationInd: true,
            detailSegmentName: "details",
            displayChargerInd: true,
            displayTransactionInd: false
        }
    },
    async mounted() {
        this.stationDetails = JSON.parse(localStorage.getItem("stationDetailForView"));
    },
    methods: {
        navigatePreviousPage() {
            this.$router.go(-1)
        },
        changeDateFormat(dateValue) {
            return moment(dateValue).format('YYYY-MM-DD HH:mm:ss')
        },
        changeDateFormatWithoutTime(dateValue) {
            if(dateValue != null) {
                return moment(dateValue).format('DD/MMM/YYYY')
            }
        },
        convertUppercase(value) {
            return value.toUpperCase()
        },
        newSegmentChanged(event) {
            if(event.detail.value == "station") {
                this.displayStationInd= true;
            } else if(event.detail.value == "charger") {
                this.displayStationInd= false;
                this.displayChargerInd = true;
            }
        },
        chargerDetailSegmentChanged(event) {
            // if(event.detail.value == "details") {
            //     this.displayChargerInd= true;
            //     this.displayTransactionInd = false;
            // } else if(event.detail.value == "session") {
            //     this.displayChargerInd= false;
            //     this.displayTransactionInd = false;
            // } else if(event.detail.value == "transactions") {
            //     this.displayChargerInd= false;
            //     this.displayTransactionInd = true;
            // }
            if(event == "details") {
                this.displayChargerInd= true;
                this.displayTransactionInd = false;
            } else if(event == "session") {
                this.displayChargerInd= false;
                this.displayTransactionInd = false;
            } else if(event == "transactions") {
                this.displayChargerInd= false;
                this.displayTransactionInd = true;
            }
        },
        selectSegment(seg){
            if(seg == "station") {
                this.displayStationInd= true;
            } else if(seg == "charger") {
                this.displayStationInd= false;
                this.displayChargerInd = true;
            }
        }
    }
})
</script>

<style scoped>
ion-segment {
    --background: grey;
}
ion-segment-button {
  /* border: 1px solid #1fe080; */
  border: 2px solid #0e3457;
  border-radius: 5px;
  margin: 1px;
}
.section-head {
    text-align: left;
    font-family: "Roboto Medium";
    font-size: 15px;
    letter-spacing: 0;
    color: #041648;
    opacity: 1;
}
.section-head-dum {
    font-family: "Roboto Medium";
    font-size: 15px;
    letter-spacing: 0;
    color: #041648;
    opacity: 1;
    margin-left: 10px;
    margin-top: 10px;
}
.section-item {
    height: 35px;
    text-align: left;
    font-family: "Roboto Medium";
    font-size: 13px;
    letter-spacing: 0;
    color: #000000;
    opacity: 0.9;
}
.section-detail {
    font-size: 13px;
    color: #000000;
    opacity: 0.5;
    font-weight: bold;
}
.station-name{
    font-weight: bold;
    color: #c8412b;
}
.list-head ion-label{
    color: #041648;
    font-size: 13px;
    font-weight: bold;
}
.station-list {
    padding: 10px;
    font-size: 14px;
    border-bottom: 1px solid grey;
    background: #dadcdf;
}
.title-wrapper ion-title {
    font-weight: 500;
    padding-top: 0px;
    /* padding-top: 15px; */
    margin-left: 45px;
    position: static;
    
    font-family: "Roboto";
    font-size: 13px;
    color: #495057;
    /* top: 6px; */
}
.general-info {
    border: 1px solid #EAEAEA;
    /* width: 30%; */
    padding: 5px;
    height: auto;
    margin: 10px;
    background: #f0f0f0;
    border-radius: 10px;

}
.details-title {
    font-family: "Roboto Medium";
    font-size: 13px;
    letter-spacing: 0;
    color: #041648;
    /* opacity: 1;
    margin-left: 20px;
    margin-left: 20px; */
    margin: 0;
    padding: 0;
    text-align: right;
}
.details-title-dum {
    font-family: "Roboto Medium";
    font-size: 13px;
    letter-spacing: 0;
    color: #041648;
    /* opacity: 1;
    margin-left: 20px;
    margin-left: 20px; */
    margin: 0;
    padding: 0;
    text-align: center;
}
.details-subtitle {
    font-family: "Roboto Medium";
    font-size: 12px;
    letter-spacing: 0;
    color: #000000;
    opacity: 0.5;
    margin: 0;
    padding: 0;
    text-align: left;
}
.details-subtitle-dum {
    font-family: "Roboto Medium";
    font-size: 12px;
    letter-spacing: 0;
    color: #000000;
    opacity: 0.5;
    margin: 0;
    padding: 0;
    /* text-align: left; */
}
.avalilable {
    color: #77c44f;
    font-weight: bold;
    padding: 0 10px 0 10px;
    border: 1px solid #77c44f;
    font-size: 11px;
    border-radius: 3px;
}
.occupied {
    color: #74a5cb;
    font-weight: bold;
    padding: 0 10px 0 10px;
    border: 1px solid #77c44f;
    font-size: 11px;
    border-radius: 3px;
}
.unavailable {
    color: #bcbab6;
    font-weight: bold;
    padding: 0 10px 0 10px;
    border: 1px solid #77c44f;
    font-size: 11px;
    border-radius: 3px;
}
.faulted {
    color: #d9593c;
    font-weight: bold; 
    padding: 0 10px 0 10px;
    border: 1px solid #77c44f;
    font-size: 11px;
    border-radius: 3px;
}
.unreachable {
    color: #d7d52c;
    font-weight: bold;
    padding: 0 10px 0 10px;
    border: 1px solid #77c44f;
    font-size: 11px
}
/*  */
.flight-types1 {
    display: flex;
    max-width: 500px;
    width: 100%;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    position: relative;
    z-index: 1;
    margin: 0 auto;
    font-size: 14px;
    border: 2px solid #161212;
    border-radius: 5px;
    color: #a71247;

}

.flight-types1 > .inm {
  display: none;
}

.flight-types1 > .inm:checked + .lbl {
  /* color: #3395DE; */
  color: #fbfbfb;
  background: #0b344f;
  /* border-radius: 5px; */
}
.flight-types1 > .inm:nth-of-type(1):checked ~ .lbl:last-of-type:before {
  transform: translateX(calc(0% + 0px));
}
.flight-types1 > .inm:nth-of-type(2):checked ~ .lbl:last-of-type:before {
  transform: translateX(calc(100% + 0px));
}
.flight-types1 > .inm:nth-of-type(3):checked ~ .lbl:last-of-type:before {
  transform: translateX(calc(200% + 0px));
}
.flight-types1 .lbl {
  flex: 1;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.flight-types1 .lbl:last-of-type:before {
  content: "";
  display: block;
  max-width: calc(33.3333333333% - 0px);
  margin: 0px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  transform: translateX(0);
}
.flight-types1 .lbl {
  padding: 6px 3px;
  transition: color 250ms cubic-bezier(0, 0.95, 0.38, 0.98);
}
.flight-types1 .lbl:before {
  background: #fff;
  transition: all 250ms cubic-bezier(0, 0.95, 0.38, 0.98);
}
.flight-types1 .lbl:not(:last-child) {
  /* border-right: 1px solid #fff; */
  border-right: 2px solid #0a0a0a;
}
/*  */
.flight-types {
    display: flex;
    max-width: 336px;
    width: 100%;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    position: relative;
    z-index: 1;
    margin: 0 auto;
    font-size: 14px;
    border: 2px solid #161212;
    border-radius: 3px;
    /* color: #a71247; */
    color: #0a3252;
    /* font-weight: bold; */

}
.flight-types > input {
  display: none;
}
.flight-types > input:checked + label {
  /* color: #3395DE; */
  color: #fbfbfb;
  /* background: #0b344f; */
  background: #c8412b;
  /* border-radius: 2.5px; */
}
.flight-types > input:nth-of-type(1):checked ~ label:last-of-type:before {
  transform: translateX(calc(0% + 0px));
}
.flight-types > input:nth-of-type(2):checked ~ label:last-of-type:before {
  transform: translateX(calc(100% + 0px));
}
.flight-types > input:nth-of-type(3):checked ~ label:last-of-type:before {
  transform: translateX(calc(200% + 0px));
}
.flight-types label {
  flex: 1;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.flight-types label:last-of-type:before {
  content: "";
  display: block;
  max-width: calc(33.3333333333% - 0px);
  margin: 0px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  transform: translateX(0);
}
.flight-types label {
  padding: 6px 3px;
  transition: color 250ms cubic-bezier(0, 0.95, 0.38, 0.98);
}
.flight-types label:before {
  background: #fff;
  transition: all 250ms cubic-bezier(0, 0.95, 0.38, 0.98);
}
.flight-types label:not(:last-child) {
  /* border-right: 1px solid #fff; */
  border-right: 2px solid #0a0a0a;
}

body,
html {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  background-color: #3395DE;
}
</style>